import { Modal } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../../../components/dashboards/components/project-visualisation/components/Header';
import Alert from '../../../../components/dashboards/components/project-visualisation/components/Alert';
import { Style } from '../../../../components/dashboards/components/project-visualisation';
import Footer from '../../../../components/dashboards/components/project-visualisation/components/Footer';
import Table from '../../../../components/dashboards/components/project-visualisation/components/information-sources/table';

export default function AnalysisSettings({
  onChange = () => { },
  allActiveSources = [],
  isOwnData = false,
  allSubjectSources = [],
  isLoading = false,
  mode = 'app',
  allowSourceChange = true,
  setVisibleSettings = () => { },
  visibleSettings,
}) {
  const { t } = useTranslation();
  const [activeSources, setActiveSources] = useState();

  const sources = useMemo(() => {
    if (allSubjectSources) {
      return allSubjectSources.map((s) => ({ ...s, sourceName: s.label }));
    }
    return [];
  }, [allSubjectSources]);

  useEffect(() => {
    if (allActiveSources.length) {
      setActiveSources(allActiveSources);
    }
  }, [allActiveSources]);

  const _onClose = () => setVisibleSettings(false);

  const _onSubmit = () => {
    if (!allowSourceChange) {
      return;
    }

    if (!isLoading) {
      onChange(activeSources);
      _onClose();
    }
  };

  if (isOwnData) {
    return null;
  }

  if (mode === 'proxy') {
    return null;
  }

  return (
    <Modal
      footer={null}
      title={(
        <Header t={t} />
      )}
      width={630}
      className="custom-modal"
      open={visibleSettings}
      onCancel={() => setVisibleSettings(false)}
    >
      <Style>
        <div className="form-group">
          <Alert
            message="You can select which of your available information sources should be included in this analysis."
            localKey={`analysisLayout`}
          />
          <div className="row-item flex-c">
            <label className="label">{t('Source Selection')}</label>
            <Table
              value={activeSources}
              t={t}
              section="analysis"
              onChange={(key, val) => {
                if (Array.isArray(val) && val.length) {
                  setActiveSources(val);
                }
              }}
              data={sources}
              hasInfoShared={false}
            />
          </div>
        </div>
        <Footer
          onClose={_onClose}
          onSubmit={_onSubmit}
          loading={isLoading}
          t={t}
          disabledFooterText={isLoading}
        />
      </Style>

    </Modal>
  );
}
